import { makeStyles, css } from '@conexasaude/styles'

import typoMixin from '@/styles/mixins/typo-mixin'

const useStyles = makeStyles({
  container: ({ typography, colors, borderRadius }) => css`
    position: relative;
    max-width: 380px;
    padding: 32px 40px;
    border-radius: ${borderRadius.sm};
    background-color: ${colors.common.white};
    box-sizing: border-box;

    > h2 {
      ${typoMixin({ typography }, 'h2')};
      line-height: 32px;
      color: ${colors.neutral[900]};
    }

    > p {
      margin: 8px 0;
      ${typoMixin({ typography }, 'body2')};
      color: ${colors.neutral[700]};
    }

    > ul {
      margin-bottom: 24px;

      li {
        display: flex;
        align-items: center;
        ${typoMixin({ typography }, 'body2')};
        color: ${colors.neutral[700]};

        span {
          display: inline-flex;
          margin-left: 4px;
        }
      }
    }

    .password-strength__root {
      margin-bottom: 16px;
    }

    .hero-button__root {
      margin-top: 4px;
    }
  `,

  inputIcon: () => css`
    pointer-events: unset;
    cursor: pointer;
  `,

  LinkSupport: ({ colors }) => css`
    color: ${colors.common.white};
    margin-top: 16px;
    @media screen and (max-width: 768px) {
      margin: 32px;
    }
    &:hover {
      color: ${colors.common.white};
    }
  `,
})

export { useStyles }
